import { FC } from "react";
import Icon, { IconType } from "../../../Icon/Icon";
import classNames from "classnames";
import React from "react";

import styles from "./BuildingBlock.module.scss";

interface Props {
  dataQA: string;
  className?: string;
  text: string;
  icon: IconType;
}

const BuildingBlock: FC<Props> = ({ icon, text, className, dataQA }) => {
  return (
    <div data-qa={dataQA} className={classNames(styles.container, className)}>
      <Icon dataQA="icon" type={icon} />
      <span data-qa="text">{text}</span>
    </div>
  );
};

export default BuildingBlock;
